import { CalendarToday, AccessTime, LocationOn, MoneySharp } from '@mui/icons-material'
import { Activity, ActivityPageFieldVisibility, Currency } from '../../../pure-js/types/GrooverTypes'
import { ActivityMetadataItem, ActivityMetadataItemDesginType } from '../types/activity.types'
import { sv } from 'date-fns/locale/sv'
import { format } from 'date-fns'
import { formatPrice } from '../utils/activityUtils'

export const MOBILE_BREAKPOINT = '600px'
export const CONTAINER_MAX_WIDTH = '900px'

export const getActivityMetadata = (
  activity: Activity,
  currency: Currency = 'SEK',
  visibility?: ActivityPageFieldVisibility,
  fields?: string[]
): ActivityMetadataItem[] => {
  const items: ActivityMetadataItem[] = [
    { icon: CalendarToday, value: activity.startDate, label: 'Startdatum', displayId: 'calendar' },
    { icon: AccessTime, value: activity.time, label: 'Tid för kursen', displayId: 'time' },
    { icon: LocationOn, value: activity.city ?? '-', label: 'Plats', hideOnMobile: true, displayId: 'location' },
    ...(activity.eventType !== 'Parentevent'
      ? [{ icon: MoneySharp, value: formatPrice(activity.price, currency), label: 'Pris', displayId: 'price' }]
      : [])
  ]
  if (fields) {
    return items.filter((item) => {
      if (item.displayId === 'time') return fields.includes('time')
      if (item.displayId === 'location') return fields.includes('city') || fields.includes('location')
      if (item.displayId === 'price') return fields.includes('price')
      return true // calendar/startDate always shown
    })
  }
  if (!visibility) return items
  return items.filter((item) => {
    if (item.displayId === 'location') return visibility.showLocation
    if (item.displayId === 'price') return visibility.showPrice
    return true
  })
}
export const getActivityMetadataDesignType = (
  activity: Activity,
  currency: Currency = 'SEK'
): ActivityMetadataItemDesginType[] => {
  const formattedDayTime = activity.startDate
    ? `${format(new Date(activity.startDate), 'EEEE', { locale: sv }).replace(/^[a-z]/, (match) => match.toUpperCase())} – ${activity.time}`
    : activity.time

  const kursstart = activity.startDate
    ? format(new Date(activity.startDate), 'd MMMM', { locale: sv }).replace(/^\d+\s+[a-z]/, (match) =>
        match.toUpperCase()
      )
    : '-'

  return [
    {
      label: 'Dagar & tid',
      value: formattedDayTime,
      displayId: 'dayTime'
    },
    {
      label: 'Kursstart',
      value: kursstart,
      displayId: 'startDate'
    },
    {
      label: 'Tillfällen',
      value: `${activity.occations?.length ?? activity.noOfOccasions ?? '-'} tillfällen`,
      displayId: 'occasions'
    },
    ...(activity.eventType !== 'Parentevent'
      ? [
          {
            label: 'Pris',
            value: formatPrice(activity.price, currency),
            displayId: 'price'
          }
        ]
      : []),
    {
      label: 'Location',
      value: `${activity.locationId}`,
      displayId: 'location'
    },
    {
      label: 'Instruktörer',
      value: activity.instructorsNames || '-',
      displayId: 'instructors'
    }
  ]
}

export const GROUP_BY_OPTIONS = [
  { value: 'none', label: 'adminGeneralInputFieldsNoGrouping' },
  { value: 'style', label: 'adminGeneralEnumsGroupByGroupByDanceType' },
  { value: 'type', label: 'adminGeneralEnumsGroupByGroupByActivityType' },
  { value: 'city', label: 'adminGeneralEnumsGroupByGroupByCity' },
  { value: 'startdate', label: 'adminGeneralEnumsGroupByGroupByMonth' },
  { value: 'period', label: 'adminGeneralEnumsGroupByGroupByPeriod' },
  { value: 'instructors', label: 'adminGeneralEnumsGroupByGroupByInstructors' },
  { value: 'level', label: 'adminGeneralEnumsGroupByGroupByLevel' },
  { value: 'location', label: 'adminGeneralEnumsGroupByGroupByLocation' }
] as const
